/**
 * /users — legacy alias that redirects to Settings > Team.
 *
 * The redirect is unconditional (no role await): a beforeLoad role check
 * deadlocked on cold loads. RBAC for team management is enforced by the
 * Settings/Team section and the backend, and the sidebar only surfaces this
 * link to client/admin roles, so an unconditional redirect is safe.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/users')({
  beforeLoad: () => {
    throw redirect({ to: '/settings', search: { section: 'team' } });
  },
  component: () => null,
});
